import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutChargeCodeQuickInfo extends Layout {
    panelChargeCode: Panel;
    sourceChargeCode: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxPartnerValue: Textbox;
}
